import { withState } from 'recompose';

export default withState('deleteDialog', 'setDeleteDialog', false);
